import { version } from 'package.json';

export const environment = {
  production: true,
  title: 'P360° Mobile',
  googleApiKey: 'AIzaSyDnP-CmIpvnnOnm7Tyr1Av6BqVPyOC4eiY',
  env: 'PRODUCTION',
  defaultFontSize: 14,
  version: version ?? 'x.y.z',
};
